export function filterMaskedAccounts(accounts, isAdmin) {
  let new_accounts = [];
  accounts.forEach((acct) => {
    if (acct.child_masks.length === 0 || isAdmin) {
      new_accounts.push(acct);
    }
  });
  return new_accounts;
}
